import { createSearchParams, } from "react-router-dom";
import { LoginSource } from "@domains/utils/emtReportCallback";
import config from "@frameworks/web/config/domain";
import { scroller } from "react-scroll";
export var navigateRoute = function (location, navigate, destination, paramName) {
    var _a;
    var searchParams = new URLSearchParams(location.search);
    if (location.pathname) {
        var options = {
            pathname: location.pathname,
            search: "".concat(!!location.search ? location.search + "&" : "?").concat(createSearchParams((_a = {},
                _a[paramName ? paramName : "sectionName"] = destination,
                _a))),
        };
        if (searchParams.get(paramName) || searchParams.get("sectionName")) {
            searchParams.set(paramName || "sectionName", destination);
            options.search = searchParams.toString();
        }
        navigate(options, { replace: true });
    }
    scrollToSection(destination);
};
export var scrollToSection = function (scrollSectionName) {
    setTimeout(function () {
        scroller.scrollTo(scrollSectionName, {
            behaviour: "smooth",
            offset: -280,
        });
    }, 10);
};
export var getFinalShareUrl = function (sectionName, id, tabName) {
    var url = new URL(window.location.href.split("?").length > 1
        ? window.location.href.split("?")[0]
        : window.location.href.split("#").length > 1
            ? window.location.href.split("#")[0]
            : window.location.href);
    if (sectionName || id) {
        url.searchParams.append("sectionName", sectionName || id);
    }
    if (tabName && !url.searchParams.has("tabName")) {
        url.searchParams.append("tabName", tabName);
    }
    return url.toString();
};
export var getLoginSourceURL = function (loginSource) {
    if (loginSource == LoginSource.SALES)
        return config.feReportBase + "/" + LoginSource.SALES;
    return config.feReportBase;
};
